import React from 'react';
import Reveal from './Reveal';
import Eyebrow from './Eyebrow';
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from './ui/accordion';
import { Badge } from './ui/badge';
import { pillars } from '../data/content';

const Pillars = () => {
  return (
    <section id="how-i-work" className="scroll-mt-20 snap-start py-24 md:py-32">
      <div className="container">
        <Reveal>
          <Eyebrow>02 — How I work</Eyebrow>
        </Reveal>
        <Reveal delay={0.05}>
          <h2 className="max-w-2xl text-[clamp(2rem,3.6vw,3rem)] font-bold tracking-tight">
            Not a product person who codes, or a developer who does product. Both, at once.
          </h2>
        </Reveal>

        <Accordion type="single" collapsible defaultValue="people" className="mt-12 border-t border-border">
          {pillars.map((pillar, i) => (
            <Reveal key={pillar.id} delay={0.06 + i * 0.05}>
              <AccordionItem value={pillar.id} className="border-b border-border">
                <AccordionTrigger className="px-0">
                  <div className="grid w-full grid-cols-[2rem_auto_1fr] items-center gap-4 sm:grid-cols-[3rem_9rem_1fr]">
                    <span className="font-mono text-sm text-faint group-data-[state=open]:text-primary-light">0{i + 1}</span>
                    <span className="hidden font-mono text-xs uppercase tracking-wide text-accent-peach sm:block">
                      {pillar.tag}
                    </span>
                    <h3 className="text-left text-[clamp(1.1rem,2vw,1.4rem)] font-semibold text-foreground">
                      {pillar.title}
                    </h3>
                  </div>
                </AccordionTrigger>
                <AccordionContent>
                  <div className="grid grid-cols-[2rem_auto_1fr] gap-4 sm:grid-cols-[3rem_9rem_1fr]">
                    <div />
                    <div className="hidden sm:block" />
                    <div className="max-w-[62ch] space-y-4">
                      <p className="text-[1.02rem] leading-relaxed text-muted">{pillar.body}</p>
                      {pillar.skills.length > 0 && (
                        <div className="flex flex-wrap gap-2">
                          {pillar.skills.map((skill) => (
                            <Badge key={skill} variant="tag">
                              {skill}
                            </Badge>
                          ))}
                        </div>
                      )}
                      {pillar.achievement && (
                        <p className="border-l-2 border-accent-amber/50 pl-3 text-sm text-accent-amber">
                          {pillar.achievement}
                        </p>
                      )}
                    </div>
                  </div>
                </AccordionContent>
              </AccordionItem>
            </Reveal>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default Pillars;
